import { useContext, useEffect, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import UserContext from "src/provider/state-manager/userProvider"
import ApiContext from "src/provider/API/call-service"
import { Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { AppCenterPopupD3, CenterPopupHeaderD3, TxPinVerificationD3 } from "src/component"
import { ICardProfile, IDeliveryOption } from "src/model"
import { moneyFormat } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"


export const RequestNewCardD3: React.FC<any> = ({dataForCard, close}) => {
    const {API} = useContext(ApiContext)
    const {user: {accountInfo, accountWithBalanceDetails}} = useContext(UserContext)
    const [input, setInput] = useState({accountNumber: '', bin: '', deliveryOptionShortForm: '', nameOnCard: '', pin: ''})
    const [view, setView] = useState('request-card')
    const {info:institutionData} = useContext(AppInfoContext)

    useEffect(() => {
        if (accountWithBalanceDetails?.length === 1) setInput({...input, accountNumber: accountWithBalanceDetails[0].nuban})
    }, [accountWithBalanceDetails])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        if (e.target.name === 'nameOnCard' && e.target.value.length > 20) return false
        setInput({...input, [e.target.name]: e.target.value})
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        await API.logCardRequest(input)
        close()
    }

    return (
        <>
            { view === 'request-card' &&
                <AppCenterPopupD3 height='53' zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD3 title='Request New Card' close={close} />
                    <CustomContainer 
                        height="53"
                        style={{maxHeight: '85%'}}
                        className="popup-content-container"
                    >
                        <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Account Number</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='accountNumber'
                                        value={input.accountNumber}
                                        style={{color: input.accountNumber ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Account</option>
                                        {
                                            accountWithBalanceDetails?.map((item: any, index: number) => {
                                                return (
                                                    <option 
                                                        value={item.nuban} 
                                                        key={index}
                                                    >
                                                        {item.nuban} - ({moneyFormat(item?.balance?.withdrawableAmount,institutionData?.defaultCurrency)})
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroupWithIcon>
                                <label>Card Type</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='bin'
                                        value={input.bin}
                                        style={{color: input.bin ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Card Type</option>
                                        {
                                            dataForCard?.cardProfiles?.map((item: ICardProfile, index: number) => {
                                                return (
                                                    <option value={item.bin} key={index}>{item.displayName}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Name on Card</label>
                                <input 
                                    placeholder='Enter Name on Card' 
                                    name='nameOnCard'
                                    value={input.nameOnCard}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroupWithIcon>
                                <label>Card Delivery</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='deliveryOptionShortForm'
                                        value={input.deliveryOptionShortForm}
                                        style={{color: input.deliveryOptionShortForm ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        required
                                    >
                                        <option value="">Select Pickup Branch</option>
                                        {
                                            dataForCard?.deliveryOptions?.map((item: IDeliveryOption, index: number) => {
                                                return (
                                                    <option value={item.shortForm} key={index}>{item.optionDescription}</option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FlexRow topMargin='2.5'>
                                <Button 
                                    width='100' sizeUnit="%" height='4.4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </AppCenterPopupD3>
            }
            { view === 'pin' &&
                <TxPinVerificationD3
                    close={close}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
        </>
    )
}